import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OuiValidationError } from 'omnium-ui/form-field';

@Component({
  selector: 'app-allocation-zone-libre-dual-textarea',
  templateUrl: './allocation-zone-libre-dual-textarea.component.html',
  styleUrls: ['./allocation-zone-libre-dual-textarea.component.scss'],
})
export class AllocationZoneLibreDualTextareaComponent {
  @Input({ required: true }) primaryControl: FormControl<string | null>;
  @Input({ required: true }) secondaryControl: FormControl<string | null>;
  @Input({ required: true }) primaryLabel: string;
  @Input({ required: true }) secondaryLabel: string;
  @Input() errors: OuiValidationError[] = [];
}
